import HttpUtil from "@/utils/HttpUtil";
import Vue from "vue";


export default {
    /**
     * 登录
     * @param account
     * @param password
     * @returns {Promise<unknown>}
     */
    
    login(account,password){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/adminAuth/login",{
                account,password
            }).then(res=>{
                if (res.code === "ok"){ 
                    resolve(res.body);
                    localStorage.setItem("Authorization",res.body)
                }else{
                    reject(res.message);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    /**
     * 当前登录状态
     * @returns {Promise<unknown>}
     */
    current(){
        return new Promise((resolve,reject)=>{
            let cookies = document.cookie.split(";");
            for (let cookie of cookies) {
                let cookiePair = cookie.split("=",2);
                if (cookiePair[0].trim() === "root-admin-session-id"){
                    let session = localStorage.getItem("is_login");
                    if (session == null){
                        reject('未登录/登陆失败');
                    }else {
                        //验证时间
                        resolve(JSON.parse(localStorage.getItem("is_login")));
                    }
                }
            }

            reject("登录数据丢失");
        });
    },
    /**
     * 退出登录
     */
    logout(){
        return new Promise((resolve,reject)=>{
            localStorage.removeItem("Authorization");
            sessionStorage.clear()
            HttpUtil.get("/auth-provider/adminAuth/logout")
                .then(()=>{
                    resolve()
                }).catch((e)=>{
                    console.log("退出时发生异常",e)
                    reject(e);
            })
        });
    }

}
